import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { BarChart3, Activity, TrendingUp } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import Layout from '../components/Layout';

// Import des composants existants
import Analytics from './Analytics';
import RCSEventsLive from './RCSEventsLive';

export default function EventsAnalytics() {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'analytics';

  const handleTabChange = (value) => {
    setSearchParams({ tab: value });
  };

  return (
    <Layout>
      <div className="space-y-6" data-testid="events-analytics-page">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
              <BarChart3 className="h-7 w-7 text-indigo-600" />
              Statistiques & Événements
            </h1>
            <p className="text-slate-500 mt-1">
              Analysez vos performances et suivez les événements en temps réel
            </p>
          </div>
        </div>

        {/* Tabs */}
        <Tabs value={defaultTab} onValueChange={handleTabChange} className="w-full">
          <TabsList className="grid w-full max-w-md grid-cols-2 mb-6">
            <TabsTrigger value="analytics" className="flex items-center gap-2" data-testid="tab-analytics">
              <TrendingUp className="h-4 w-4" />
              Analytics
            </TabsTrigger>
            <TabsTrigger value="events" className="flex items-center gap-2" data-testid="tab-events">
              <Activity className="h-4 w-4" />
              Événements Live
            </TabsTrigger>
          </TabsList>

          <TabsContent value="analytics" className="mt-0">
            <Analytics embedded={true} />
          </TabsContent>

          <TabsContent value="events" className="mt-0">
            <RCSEventsLive embedded={true} />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
